import React from "react";

// Top-level React error boundary. Without this, any uncaught render/lifecycle
// error blanks the whole app (white screen). This catches it and shows a
// recoverable message instead. Note: this only catches errors thrown during
// React rendering — async/event-handler errors are handled by the toast layer.
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error("Unhandled UI error:", error, info?.componentStack);
  }

  handleReload = () => {
    if (typeof window !== "undefined") window.location.reload();
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div
        role="alert"
        style={{
          position: "fixed",
          inset: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background:
            "linear-gradient(135deg, #16323a 0%, #0c1a20 60%, #0c1418 100%)",
          color: "#f1f5f9",
          padding: 24,
          zIndex: 99999,
        }}
      >
        <div style={{ maxWidth: 420, textAlign: "center" }}>
          <div style={{ fontSize: 20, fontWeight: 700, marginBottom: 8 }}>
            Something went wrong
          </div>
          <div
            style={{
              fontSize: 14,
              color: "rgba(241,245,249,0.75)",
              marginBottom: 20,
              lineHeight: 1.5,
            }}
          >
            The designer hit an unexpected error and needs to reload. Your last
            saved work is safe.
          </div>
          <button
            type="button"
            onClick={this.handleReload}
            style={{
              padding: "10px 22px",
              borderRadius: 10,
              border: "none",
              background: "#dad84f",
              color: "#0d1117",
              fontWeight: 700,
              cursor: "pointer",
            }}
          >
            Reload
          </button>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
